import { INSIGHTS_PANEL, VIEW_SETTINGS_PANEL } from '../../../model/panels/constants';
import type { State } from '../../types';

export const getPanels = (state: State) => state.ui.panels;

export const getInsightsPanel = (state: State) => state.ui.panels?.[INSIGHTS_PANEL] || false;

export const getViewSettingsPanel = (state: State) =>
	state.ui.panels?.[VIEW_SETTINGS_PANEL] || false;
